import { defineComponent as _defineComponent } from 'vue'
import {
  externalReviews,
  getSurveyStatus,
  ReviewNovikov,
  ReviewTopBlock,
  ReviewReturn,
  ReviewPrimehill,
  ReviewStars,
  ReviewSuggestions,
  ReviewLikes,
  ReviewComments,
  ReviewLinksList,
  ReviewMailings
} from '@entities/review'
import { ref, onMounted, computed, useContext } from '@nuxtjs/composition-api'
import { IWaiter } from '@entities/order/model/types'
import { useThemeModel } from '@entities/theme'
import { IExternalReviewsItem, ISuggestion, IRating } from '@entities/review/model/types'
import { sendMessage } from '@features/telegram'
import { useRestaurantModel } from '@entities/restaurant'
import { generateWishes, generateWaiterName, generateMessage } from './../utils'
import { ModalBotton, AppButton } from '@shared/ui'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
import { useOrderModel } from '@entities/order'
import { useLoyaltyModel } from '~/src/entities/loyalty'
// import QuizBonus from '~/src/widgets/quiz-bonus/QuizBonus.vue'
// import DigitalFatherModal from '~/src/widgets/digital-father-modal/DigitalFatherModal.vue'
import AbpayModal from '~/src/widgets/abpay-modal/AbpayModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  emits: [
  'callYandexMetricGoal',
  'closeReview',
  'checkPrecheck'
],
  setup(__props, { emit }) {

const { $cookies } = useContext()



const themeModel = useThemeModel()
const restaurantModel = useRestaurantModel()
const orderModel = useOrderModel()
const loyaltyModel = useLoyaltyModel()

// Data
const waiter = ref<IWaiter | null>(null)
const rating = ref<number>(0)
const platforms = ref<IExternalReviewsItem[]>([])
const reviewLinksListStatus = ref<boolean>(false)
const comment = ref<string>('')
const disabletBtn = ref<boolean>(false)
const reviewCollectingContactsModal = ref<boolean>(false)
const advertisingActive = ref<boolean>(false)
const consentMailing = ref<boolean>(false)
const suggestions = ref<ISuggestion[]>([])
const ratingInfo = ref<IRating[]>([])
const surveyEnabled = ref<boolean>(false)

const tipsType = computed(() => orderModel.orderData && orderModel.orderData.tipsType ? orderModel.orderData.tipsType : '')

const reviewReturnIsShow = computed(() => {
  return !!(waiter.value && waiter.value.tips_link && tipsType.value === 'LINK')
})

// PrimeHill/iikoCard
const displayBonuses = computed(() => {
  const loyaltyCode = orderModel.orderData?.global_system_loyalty?.code
  if (loyaltyCode === 'prime_hill') {
    return !(orderModel.orderData.global_system_loyalty?.application_loyalty &&
      loyaltyModel.sumDiscountPrimeHill &&
      !orderModel.orderData.bonus)
  } else if (loyaltyCode === 'iiko_card') {
    return !(orderModel.orderData.global_system_loyalty?.application_loyalty &&
      loyaltyModel.sumDiscountPrimeHill &&
      !orderModel.orderData.bonus)
  }

  return false
  // return orderModel.orderData?.global_system_loyalty?.name === 'Prime Hill' && !(orderModel.orderData.global_system_loyalty?.application_loyalty && loyaltyModel.sumDiscountPrimeHill && !orderModel.orderData.bonus)
})

const checkReviewLinksList = computed(() => {
  return platforms.value.length ? platforms.value.filter(i => i.active && i.url) : []
})

// Methods

// Получение статуса опроса
const fetchSurveyStatus = async (shopId: number) => {
  if (!shopId) {
    surveyEnabled.value = false
    return
  }

  try {
    const response = await getSurveyStatus(shopId)
    if (response.success) {
      surveyEnabled.value = response.is_enabled
      // Передаем статус баланса SMS в модель опроса
      if (response.is_enabled) {
        const { useQuizBonusModel } = await import('@entities/quiz-bonus')
        const quizBonusModel = useQuizBonusModel()
        quizBonusModel.setSmsBalanceOk(response.sms_balance_ok)
      }
    } else {
      surveyEnabled.value = false
    }
  } catch {
    surveyEnabled.value = false
  }
}

// Ьщвфдка с ссылками
const closeModalLinks = () => {
  reviewLinksListStatus.value = false
}

// Яндекс метрика
const callYandexMetricGoal = (goal: string) => {
  emit('callYandexMetricGoal', goal)
}

// Клик по звездочкам
const handleRating = (val: number) => {
  rating.value = val
  if (val === 5 && checkReviewLinksList.value.length) {
    reviewLinksListStatus.value = true
  }
  // if (val > 0 && !this.checkReviewLinksList.length) {
  //   this.reviewCollectingContactsModal = true
  // }
}

// Клик по предложениям
const selectSuggestion = (payload: {type: string, tags: ISuggestion[] | IRating[]}) => {
  if (payload.type === 'suggestions') {
    suggestions.value = payload.tags as ISuggestion[]
  } else {
    ratingInfo.value = payload.tags as IRating[]
  }
}

// Комментарий
const onChangeComment = (val: string) => {
  comment.value = val
}

// Отправка сообщения
const sendReview = async () => {
  if (disabletBtn.value) {
    return
  }
  emit('callYandexMetricGoal', 'review')
  if (comment.value.length || rating.value > 0) {
    disabletBtn.value = true

    // Генерация имени официанта
    const waiterName = generateWaiterName(waiter.value)

    // Генерация пожеланий
    const wishes = generateWishes(rating.value, suggestions.value, ratingInfo.value)

    // Текст сообщения
    const textOfMessage = generateMessage(
      orderModel.transactionData,
      restaurantModel.tableCode,
      waiterName,
      comment.value,
      rating.value,
      wishes
    )

    const userId = orderModel.orderData && orderModel.orderData.waiter ? orderModel.orderData.waiter.id : null

    const transactionLastId = orderModel.transactionData?.session_ids?.paid_transaction_ids.at(-1)

    await sendMessage({
      shopCode: restaurantModel.code,
      message: textOfMessage,
      messageType: 'RATING',
      transactionId: transactionLastId,
      orderId: null,
      userId
    })
  }
  emit('closeReview')
  disabletBtn.value = true
  $cookies.set('scrollTipsCookies', null)
}

const closeCollectingContactsModal = () => {
  reviewCollectingContactsModal.value = false
}

// Включить/Выключить согласие на рекламу
const toggleAdvertisingActive = () => {
  advertisingActive.value = !advertisingActive.value
}

const toggleConsentMailing = () => {
  consentMailing.value = !consentMailing.value
}

const closeConsentMailing = () => {
  consentMailing.value = false
}

onMounted(async () => {
  emit('callYandexMetricGoal', 'returnRating')

  // Получение статуса опроса
  if (orderModel.orderData?.settings?.shop_id) {
    const shopId = parseInt(orderModel.orderData.settings.shop_id)
    await fetchSurveyStatus(shopId)
  }

  // Получение ссылок для отзывов
  if (orderModel.orderData?.settings) {
    platforms.value = await externalReviews(parseInt(orderModel.orderData?.settings.shop_id))
  }

  // Кол-во бонусов
  const primeHillPhone = await $cookies.get('primeHillPhone')
  const transactionId = orderModel.transactionData?.session_ids?.paid_transaction_ids[0]
  if (displayBonuses.value && primeHillPhone && transactionId) {
    if (orderModel.orderData?.global_system_loyalty?.code === 'prime_hill') {
      await loyaltyModel.fetchUserBalanceBonus(transactionId)
    } else if (orderModel.orderData?.global_system_loyalty?.code === 'iiko_card') {
      await loyaltyModel.fetchUserBalanceBonusIikoCard(transactionId)
    }
  }

  // Официант
  waiter.value = null
  if (orderModel.transactionData && orderModel.transactionData.waiter) {
    waiter.value = {
      ...orderModel.transactionData.waiter,
      display_name: orderModel.transactionData.waiter.status !== 'VERIFIED' ? 'Неизвестный официант' : orderModel.transactionData.waiter.display_name
    }
  }

  // Amplitude
  if (orderModel.transactionData && orderModel.transactionData.transaction_payment) {
    amplitudeLogEvent(amplitudeEvents.COMPLETE_PAYMENT,
      { Чаевые: !!orderModel.transactionData.transaction_payment.tips, СервисныйСбор: !!orderModel.transactionData.transaction_payment.fee })
  }
  emit('checkPrecheck')
})


return { __sfc: true,$cookies, emit, themeModel, restaurantModel, orderModel, loyaltyModel, waiter, rating, platforms, reviewLinksListStatus, comment, disabletBtn, reviewCollectingContactsModal, advertisingActive, consentMailing, suggestions, ratingInfo, surveyEnabled, tipsType, reviewReturnIsShow, displayBonuses, checkReviewLinksList, fetchSurveyStatus, closeModalLinks, callYandexMetricGoal, handleRating, selectSuggestion, onChangeComment, sendReview, closeCollectingContactsModal, toggleAdvertisingActive, toggleConsentMailing, closeConsentMailing, ReviewNovikov, ReviewTopBlock, ReviewReturn, ReviewPrimehill, ReviewStars, ReviewSuggestions, ReviewLikes, ReviewComments, ReviewLinksList, ReviewMailings, ModalBotton, AppButton, AbpayModal }
}

})